import React from 'react';

const WIDTH = 112, HEIGHT = 26, GAP = 6;
const overlaps = (a, b) => a.left < b.left + b.width + GAP && a.left + a.width + GAP > b.left
  && a.top < b.top + b.height + GAP && a.top + a.height + GAP > b.top;

export const positionAgentCallouts = (markers, technical, chart, candles, host) => {
  const width = chart.timeScale().width(), height = host.clientHeight - chart.timeScale().height();
  if (width < WIDTH + 8 || height < HEIGHT + 8) return [];
  const occupied = [...(technical?.placed || []), ...(technical?.compact || []).map(item => ({ ...item, width: 14, height: 16 }))];
  const placed = [];
  for (const marker of markers) {
    const labelWidth = Number.isFinite(marker.label_width) ? Math.max(48, Math.min(WIDTH, marker.label_width)) : WIDTH;
    const anchorX = chart.timeScale().timeToCoordinate(marker.time), anchorY = candles.priceToCoordinate(marker.anchor_price ?? marker.reference_price);
    if (!Number.isFinite(anchorX) || !Number.isFinite(anchorY) || anchorX < 0 || anchorX > width || anchorY < 0 || anchorY > height) continue;
    const preferred = marker.action === 'buy' ? anchorY + 20 : anchorY - HEIGHT - 20;
    const columns = [...new Set([Math.max(4, Math.min(width - labelWidth - 4, anchorX - labelWidth - 18)), 4,
      Math.max(4, width - labelWidth - 4), Math.max(4, (width - labelWidth) / 2)])];
    const options = [];
    for (const left of columns) for (let top = 4; top + HEIGHT < height - 4; top += HEIGHT + GAP) {
      const box = { left, top, width: labelWidth, height: HEIGHT };
      if (![...occupied, ...placed].some(other => overlaps(box, other))) options.push({ ...box, distance: Math.abs(top - preferred) + Math.abs(left + labelWidth / 2 - anchorX) * .3 });
    }
    options.sort((a, b) => a.distance - b.distance);
    if (options.length) placed.push({ ...marker, ...options[0], anchorX, anchorY });
  }
  return placed;
};

export const installAgentCallouts = ({ chart, candles, host, getSettings, onLayout }) => {
  let frame = null, stopped = false, previous = '';
  const update = () => {
    frame = null;
    if (stopped) return;
    const { markers, technical } = getSettings();
    const next = positionAgentCallouts(markers, technical, chart, candles, host), serialized = JSON.stringify(next);
    if (serialized !== previous) { previous = serialized; onLayout(next); }
  };
  const schedule = () => { if (!stopped && frame === null) frame = requestAnimationFrame(update); };
  const primitive = { updateAllViews: schedule, paneViews: () => [] };
  candles.attachPrimitive(primitive);
  chart.timeScale().subscribeVisibleLogicalRangeChange(schedule);
  chart.timeScale().subscribeSizeChange(schedule);
  const observer = new ResizeObserver(schedule); observer.observe(host);
  return { refresh: schedule, destroy: () => {
    stopped = true; observer.disconnect(); if (frame !== null) cancelAnimationFrame(frame);
    chart.timeScale().unsubscribeVisibleLogicalRangeChange(schedule); chart.timeScale().unsubscribeSizeChange(schedule);
    candles.detachPrimitive(primitive);
  } };
};

export const ChartAgentCallouts = ({ layout }) => <div className="chart-agent-callout-layer" data-testid="research-agent-callouts">
  <svg aria-hidden="true">{layout.map(item => <path key={item.id} d={`M ${item.anchorX} ${item.anchorY} L ${item.left + item.width / 2} ${item.top + item.height / 2}`} stroke={item.color} strokeWidth="1" strokeDasharray="3 3" fill="none" />)}</svg>
  {layout.map(item => <div key={item.id} className={`chart-agent-callout ${item.action}`} role="img" data-testid={`research-agent-callout-${item.agent}`} data-action={item.action} data-candle-time={item.time} data-reference-price={item.reference_price}
    aria-label={`${item.name}: ${item.action === 'hold' ? 'Hold, no Buy or Sell' : item.action === 'sell' ? 'Sell, reduce or exit long' : 'Buy, conditional long'}. Latest reviewed candle.`}
    style={{ left: item.left, top: item.top, width: item.width, height: item.height, borderColor: item.color, color: item.color }}><span aria-hidden="true">{item.action === 'buy' ? '↑' : item.action === 'sell' ? '↓' : '○'}</span>{item.text}</div>)}
</div>;